import React from "react";

export default function ActivityIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_101_10044)">
        <path
          d="M0.75 0.75C3 5.25 1.875 6.375 4.125 8.625C4.125 8.625 6.228 8.625 7.38422 7.60837C6.25955 8.79364 5.63385 10.3661 5.63672 12C5.66156 13.6713 6.34291 15.2657 7.53355 16.4387C8.7242 17.6118 10.3286 18.2694 12 18.2694C13.6714 18.2694 15.2758 17.6118 16.4664 16.4387C17.6571 15.2657 18.3384 13.6713 18.3633 12C18.3683 10.3845 17.7587 8.82766 16.6582 7.64503C17.8228 8.62486 19.875 8.625 19.875 8.625C22.125 6.375 21 5.25 23.25 0.75C18.75 3 17.625 1.875 15.375 4.125C15.375 4.125 15.3752 6.21563 16.3828 7.37405C15.2028 6.25231 13.6378 5.62546 12.0098 5.62246C10.3817 5.61947 8.8144 6.24054 7.63031 7.35792C8.62439 6.19641 8.625 4.125 8.625 4.125C6.375 1.875 5.25 3 0.75 0.75ZM4.125 15.375C1.875 17.625 3 18.75 0.75 23.25C5.25 21 6.375 22.125 8.625 19.875C8.625 19.875 8.625 17.625 7.5 16.5C6.375 15.375 4.125 15.375 4.125 15.375ZM19.875 15.375C19.875 15.375 17.625 15.375 16.5 16.5C15.375 17.625 15.375 19.875 15.375 19.875C17.625 22.125 18.75 21 23.25 23.25C21 18.75 22.125 17.625 19.875 15.375Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_10044">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
